<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b" id="author"><a id="page_11">Author’s Note</a></h2><a id="page_11">
<p class="indent">All views are my own and do not reflect those of my employing agency or the United States government.</p>
</a><p class="noindent"><a id="page_11"></a><a id="page_12"></a></p><a id="page_12">
</a><p class="noindent"><a id="page_12"></a><a id="page_13"></a></p><a id="page_13">
</a><p class="noindent"><a id="page_13"></a><a id="page_14"></a></p><a id="page_14">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// author.vue?968ac65a